var _rect, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContacto(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 8,
    fill: "url(#paint0_linear_753_18717)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M11.1986 20.3149C10.1308 14.9306 13.5006 10.2528 18.132 7.50532C19.8856 6.46508 22.1278 7.0824 23.1403 8.88415L26.3008 14.5088C27 15.7532 26.585 17.3444 25.3739 18.0629C23.5596 19.1392 22.572 21.2575 23.132 23.3318C23.612 25.1102 24.3411 27.3205 25.3853 29.3449C26.6702 31.836 28.5566 34.0916 30.0822 35.6919C31.5481 37.2296 33.8254 37.4092 35.6395 36.333C36.8508 35.6144 38.3997 36.0408 39.099 37.2854L41.5082 41.5729C42.5206 43.3746 41.9198 45.6785 40.1663 46.7188C35.5348 49.4663 29.9072 50.1259 25.903 46.4836C23.1688 43.9966 19.9244 40.2081 16.7115 34.4903C13.4987 28.7725 11.9278 23.9913 11.1986 20.3149Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2283 21.6872C14.337 17.2644 17.1497 13.4219 21.0155 11.1651C22.4791 10.3106 24.3507 10.8177 25.1957 12.2977L27.8337 16.9179C28.4173 17.9401 28.071 19.2472 27.0601 19.8374C25.5457 20.7214 24.7214 22.4616 25.1888 24.1654C25.5895 25.6262 26.198 27.4419 27.0695 29.1047C28.1421 31.151 29.7166 33.0038 30.99 34.3184C32.2135 35.5815 34.1143 35.729 35.6286 34.8449C36.6396 34.2547 37.9324 34.605 38.5161 35.6273L40.527 39.1492C41.372 40.6292 40.8706 42.5217 39.4069 43.3761C35.5411 45.633 30.8439 46.1749 27.5017 43.1829C25.2196 41.14 22.5115 38.0281 19.8298 33.3313C17.1481 28.6346 15.8369 24.7071 15.2283 21.6872Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_753_18717",
    x1: 0,
    y1: 0,
    x2: 56.0786,
    y2: 0.0788608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5296D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B58CA"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacto);
export default __webpack_public_path__ + "static/media/Contacto.090696858f6db56c454aa28a20b71504.svg";
export { ForwardRef as ReactComponent };